export const getPublicURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://www-dev.telia.ee';
        case 'test':
            return 'https://www-test.telia.ee';
        case 'live':
            return 'https://www.telia.ee';
    }
};
export const getSelfServiceURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://iseteenindus-dev.telia.ee';
        case 'test':
            return 'https://iseteenindus-test.telia.ee';
        case 'live':
            return 'https://iseteenindus.telia.ee';
    }
};
export const getShopURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://pood-dev.telia.ee';
        case 'test':
            return 'https://pood-test.telia.ee';
        case 'live':
            return 'https://pood.telia.ee';
    }
};
export const getOnlineHelpURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://www-dev.telia.ee/abi';
        case 'test':
            return 'https://www-test.telia.ee/abi';
        case 'live':
            return 'https://www.telia.ee/abi';
    }
};
export const getMinuTvURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://dev.minutv.ee/#/home';
        case 'test':
            return 'https://dev.minutv.ee/#/home';
        case 'live':
            return 'https://www.minutv.ee/#/home';
    }
};
export const getBrandFreeURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://andmed-dev.telia.ee';
        case 'test':
            return 'https://andmed-test.telia.ee';
        case 'live':
            return 'https://andmed.telia.ee';
    }
};
export const getAPIBaseURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://www-dev.telia.ee/common/api';
        case 'test':
            return 'https://www-test.telia.ee/common/api';
        case 'live':
            return 'https://www.telia.ee/common/api';
    }
};
export const getSearchAPIBaseUrl = (tier) => {
    return `${getPublicURL(tier)}/search/api`;
};
export const getNotificationApiBaseUrl = (tier) => {
    return `${getPublicURL(tier)}/notification/api`;
};
export const getSSOBackendURL = (tier) => {
    switch (tier) {
        case 'dev':
            return 'https://sso-arendus.telia.ee';
        case 'test':
            return 'https://sso-test.telia.ee';
        case 'live':
            return 'https://sso.telia.ee';
    }
};
//# sourceMappingURL=environmentURL.js.map